const de = {
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    close: 'Schließen',
    all: 'Alle',
    none: 'Keine',
    name: 'Name',
    description: 'Beschreibung',
    color: 'Farbe',
    type: 'Typ',
    yes: 'Ja',
    no: 'Nein',
    search: 'Suchen',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    rename: 'Umbenennen',
    removeAll: 'Alle entfernen',
    selected: '{{count}} gewählt',
    resetFilters: 'Filter zurücksetzen',
    noOptions: 'Keine Optionen',
    general: 'Generell',
    escCancel: 'ESC Abbrechen',
    cmdEnterSave: 'Cmd+Enter Speichern',
    enterSave: 'Enter Speichern',
    escCmdEnter: 'ESC \u00b7 \u2318Enter',
    dragToReorder: 'Ziehen zum Umsortieren',
    dropHere: 'Hier ablegen',
    moveTo: 'Verschieben nach:',
    dragOrClickToChangeTeam: 'Ziehen oder klicken um Team zu wechseln',
  },
  nav: {
    roadmap: 'Roadmap',
    overview: 'Übersicht',
    columns: 'Columns',
    canvas: 'Canvas',
    editor: 'Editor',
    employees: 'Mitarbeiter',
    categories: 'Kategorien',
    boards: 'Boards',
    tasks: 'Tasks',
    teams: 'Teams',
    skills: 'Skills',
    boardSection: 'Board',
    globalSection: 'Übergreifend',
    selectBoard: 'Board wählen...',
    newBoard: 'Neues Board',
    addTooltip: '{{label}} hinzufügen',
    exportTooltip: 'Exportieren',
    importTooltip: 'Importieren',
    adrs: 'ADRs',
    resources: 'Resources',
    searchBoards: 'Board suchen...',
    noResults: 'Kein Board gefunden',
  },
  landing: {
    heroHeadline: 'Discovery. Roadmap. Daily.\nKein Signup. Unbegrenzt nutzbar.',
    heroSub: 'Canvas, Timeline, PERT-Schaetzungen und Skill-Matrix — verbunden statt verteilt auf vier Tools. Ohne Account, ohne Cloud, ohne Limits.',
    tryBoard: 'Board ausprobieren',
    createOwnBoard: 'Eigenes Board erstellen',
    featuresLabel: 'Werkzeuge',
    featuresHeading: 'Was dahinter steckt',
    featuresSub: 'Vier Werkzeuge die in jeder Phase zusammenspielen — auf dem Board, in der Roadmap und in der Übersicht. Änderungen wirken sofort überall.',
    pertTitle: 'PERT-Schaetzungen',
    pertDesc: 'Drei Schätzwerte pro Task — oder individuell pro Person. Auf dem Board erfasst, in der Roadmap sichtbar, in der Übersicht als Risiko aggregiert. Aus Robert C. Martins "The Clean Coder".',
    interactiveRoadmap: 'Gantt-Timeline',
    interactiveRoadmapDesc: 'Die Roadmap-Ansicht: Drag & Drop, stufenloser Zoom, vier Detail-Level. Stakeholder sehen wann was fertig wird und wie sich Änderungen auswirken.',
    canvas: 'Canvas',
    canvasDesc: 'Tech-Trees, Infrastruktur, Projektstruktur — als Freiflaeche. Layer, Gruppen, Verbindungen. Der Dependency Explorer hebt einzelne Pfade hervor.',
    teamScheduling: 'Skills & Konflikte',
    teamSchedulingDesc: 'Skill-Matrix mit 3 Leveln und automatischem Task-Abgleich. Doppelbuchungen werden boardübergreifend erkannt — bevor sie zum Problem werden.',
    tagEstimation: 'Schaetzung',
    tagPlanning: 'Roadmap',
    tagVisualization: 'Board',
    tagResources: 'Team',
    navFeatures: 'Features',
    navDemo: 'Demo',
    getStarted: 'Loslegen',
    createCanvas: 'Canvas erstellen',
    createBoard: 'Board erstellen',
    playground: 'Playground',
  },
  boards: {
    title: 'Boards',
    createButton: 'Board erstellen',
    emptyHint: 'Neues Board anlegen, um loszulegen.',
    boardNamePlaceholder: 'Board Name',
    boardNameInputPlaceholder: 'Board Name...',
    deleteConfirm: 'Board wirklich löschen? Alle Tasks dieses Boards gehen verloren.',
    employeeCount: '{{count}} Mitarbeiter',
    start: 'Start',
  },
  categories: {
    title: 'Kategorien',
    count: '{{count}} Kategorien',
    addButton: 'Kategorie hinzufügen',
    noCategories: 'Keine Kategorien',
    noCategoriesDesc: 'Erstelle Kategorien, um Tasks zu organisieren.',
    newPlaceholder: 'Neue Kategorie...',
    deleteConfirm: 'Kategorie löschen?',
    deleteConfirmWithTasks: 'Kategorie löschen? {{count}} Tasks nutzen diese Kategorie. Die Kategorie wird aus allen Tasks entfernt.',
  },
  employees: {
    title: 'Mitarbeiter',
    subtitle: '{{count}} Mitarbeiter in {{teamCount}} Teams',
    addButton: 'Mitarbeiter hinzufügen',
    noEmployees: 'Keine Mitarbeiter',
    noEmployeesDesc: 'Füge Mitarbeiter hinzu, um Teams zu bilden und Tasks zuzuweisen.',
    noEmployeesInTeam: 'Keine Mitarbeiter in diesem Team',
    noEmployeesInSelectedTeam: 'Keine Mitarbeiter im gewählten Team',
    withoutTeam: 'Ohne Team',
    deleteConfirm: '"{{name}}" wirklich löschen?',
    yesDelete: 'Ja, löschen',
    assignEmployee: 'Mitarbeiter zuordnen',
    allAssigned: 'Alle Mitarbeiter bereits zugeordnet.',
    createNew: 'Neuen Mitarbeiter erstellen',
    clickToAddEstimate: 'Klicke auf einen Mitarbeiter um eine Schätzung hinzuzufügen',
    addEmployeeHint: 'Emoji-String für Skills (mehrfache = höheres Level)',
    assigned: 'Zugewiesen',
    assign: 'Zuweisen',
    utilization: 'Auslastung',
    weeks: 'Wochen',
    themesParallel: '{{count}} Themen parallel',
    efficiency: 'Effizienz:',
    optimalWeeks: 'optimal: {{weeks}}w',
    projects: 'Projekte:',
  },
  teams: {
    title: 'Teams',
    subtitle: '{{count}} Teams mit insgesamt {{employeeCount}} Mitarbeitern',
    addButton: 'Team hinzufügen',
    noTeams: 'Keine Teams',
    noTeamsDesc: 'Erstelle ein Team, um Mitarbeiter zu organisieren.',
    noEmployees: 'Keine Mitarbeiter',
    deleteConfirm: 'Team "{{name}}" wirklich löschen?',
    deleteWarning: 'Achtung: {{count}} Mitarbeiter sind diesem Team zugeordnet!',
    yesDelete: 'Ja, löschen',
  },
  task: {
    newTask: 'Neuer Task',
    editTask: 'Task bearbeiten',
    prevTask: 'Vorheriger Task',
    nextTask: 'Nächster Task',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Beschreibung hinzufügen...',
    consequence: 'Konsequenz',
    consequencePlaceholder: 'Konsequenz (wenn nicht umgesetzt)...',
    titlePlaceholder: 'Feature XYZ implementieren',
    estimate: 'Schätzung',
    estimateModeTask: 'Task',
    estimateModeIndividual: 'Pro Mitarbeiter',
    requiredSkills: 'Benötigte Skills',
    calculations: 'Berechnungen',
    createAndClose: 'Erstellen & Schließen',
    createAndNext: 'Erstellen & nächster',
    created: '\u2713 \u201e{{title}}\u201c erstellt',
    deleteGlobalConfirm: 'Task global löschen?',
    deleteFromBoard: 'Vom Board entfernen',
    allEstimates: 'Alle Schätzungen (O/M/P)',
    teamAndCalculation: 'Team & Berechnung',
    speed: 'Geschwindigkeit',
    risk: 'Risiko',
    alone: '{{name}} allein',
    withTeam: 'Mit Team',
    timeSaving: 'Zeitersparnis',
    skillsMissing: 'Skills nicht ausreichend \u2013 fehlend:',
    hideSensitive: 'Sensible Daten verstecken',
    showSensitive: 'Sensible Daten anzeigen',
    addTask: 'Task hinzufügen',
    deleteTaskConfirm: 'Task global löschen? Er wird von allen Boards entfernt.',
    deleteTaskButton: 'Task löschen',
    noTasks: 'Keine Tasks',
    noTasksDesc: 'Erstelle einen Task, um mit der Planung zu beginnen.',
    searchPlaceholder: 'Task suchen...',
    totalTasks: '{{count}} Tasks gesamt',
    totalTasksFiltered: '{{count}} Tasks gesamt ({{filtered}} angezeigt)',
    noTasksFound: 'Keine Tasks für die aktiven Filter gefunden.',
    noTasksExist: 'Keine Tasks vorhanden.',
    notAssigned: 'Nicht zugewiesen',
    assignEmployeeToTask: 'Mitarbeiter zuweisen',
    doubleClickToEdit: 'Doppelklick zum Bearbeiten',
    removeEmployee: '{{name}} entfernen',
    primaryResponsible: '(Hauptverantwortlich)',
    additionalPercent: '(+10%)',
    unknownSkill: 'Unbekannt',
    skillsNotAssigned: 'NICHT ZUGEWIESEN',
    skillsFulfilled: 'SKILLS ERFÜLLT',
    skillsMissingHeader: 'SKILLS FEHLEN',
    bestCaseEnd: 'Best Case Ende',
    bestCase: 'Best Case',
  },
  taskTable: {
    title: 'Titel',
    assignees: 'Assignees',
    boards: 'Boards',
    start: 'Start',
    estimate: 'Schätzung',
    noBoard: 'Kein Board',
    individualCount: '{{count}} Ind.',
    columns: 'Columns',
  },
  taskStatus: {
    all: 'Alle',
    onBoard: 'Auf Board',
    noBoard: 'Kein Board',
  },
  columns: {
    title: 'Columns',
    count: '{{count}} Columns mit insgesamt {{taskCount}} Tasks',
    dragHint: 'Columns per Drag & Drop umsortieren',
    addButton: 'Column hinzufügen',
    noColumns: 'Keine Columns vorhanden.',
    addFirst: 'Erste Column hinzufügen',
    defaultCategories: 'Standard-Kategorien (Task-Pool Filter)',
    deleteConfirm: 'Column "{{name}}" wirklich löschen?',
    deleteWarning: 'Achtung: {{count}} Tasks sind dieser Column zugeordnet!',
    yesDelete: 'Ja, löschen',
    noTasks: 'Keine Tasks',
    taskCount: '{{count}} Tasks',
    addTaskToColumn: 'Task in {{column}} hinzufügen',
    columnNameLabel: 'Column Name',
    deleteColumn: 'Column löschen',
    confirmDeleteShort: 'Wirklich löschen?',
    closeButton: 'Schließen',
    addColumnModal: {
      title: 'Neue Column hinzufügen',
      nameRequired: 'Name darf nicht leer sein',
      nameExists: 'Diese Column existiert bereits',
      existing: 'Bestehende',
    },
  },
  skills: {
    title: 'Skills',
    subtitle: '{{count}} Skills \u00b7 {{employeeCount}} Mitarbeiter',
    subtitleEmpty: 'Skills verwalten und Skill-Verteilung im Team',
    addSkillButton: 'Skill',
    fromPreset: 'Aus Preset',
    addModal: {
      addTitle: 'Neuen Skill hinzufügen',
      editTitle: 'Skill bearbeiten',
      emojiLabel: 'Emoji',
      emojiPlaceholder: 'Emoji wählen...',
      descriptionPlaceholder: 'Beschreibung des Skills...',
    },
    emptyNoSkillsNoEmployees: 'Noch keine Skills oder Mitarbeiter',
    emptyNoSkillsNoEmployeesDesc: 'Erstelle zuerst Mitarbeiter und füge dann Skills hinzu.',
    emptyNoSkills: 'Keine Skills definiert',
    emptyNoSkillsDesc: 'Füge Skills hinzu, um sie Mitarbeitern zuzuordnen.',
    addFromPreset: 'Aus Preset hinzufügen',
    singleSkill: 'Einzelnen Skill',
    deleteConfirm: '"{{name}}" wirklich löschen?',
    noEmployeesAssigned: 'Noch keine Mitarbeiter zugeordnet.',
    dropToAssign: 'Hier ablegen um zuzuordnen',
    dragToMoveSkill: 'Ziehen um in anderen Skill zu verschieben',
    removeAssignment: 'Zuordnung entfernen',
    collapse: 'Zuklappen',
    expand: 'Aufklappen',
    employeesWithSkill: 'Mitarbeiter mit diesem Skill ({{count}})',
    teamCoverage: 'Team-Abdeckung',
    noCoverage: 'Keine Team-Abdeckung vorhanden!',
    levelLegend: 'Level-Legende',
    level3Desc: 'Kann andere anleiten und komplexe Probleme lösen',
    level2Desc: 'Kann eigenständig arbeiten und mittlere Aufgaben bewältigen',
    level1Desc: 'Grundkenntnisse, benötigt Unterstützung bei komplexen Aufgaben',
    deleteSkillConfirm: 'Skill wirklich löschen?',
    deleteSkillWarning: 'Der Skill "{{name}}" wird dauerhaft gelöscht.',
    closeEsc: 'Schließen (Esc)',
  },
  overview: {
    title: 'Übersicht',
    stats: '{{taskCount}} Tasks \u00b7 ~{{weekCount}} PW',
    columnsView: 'Columns',
    timelineView: 'Timeline',
    unprioritized: 'Nicht einpriorisiert',
    unprioritizedCount: 'Nicht einpriorisiert ({{count}})',
    unprioritizedUnmatched: 'Nicht einpriorisiert (ohne Zuordnung)',
    noActiveTasks: 'Keine aktiven Tasks vorhanden.',
    hardRequirements: 'Hard Requirements',
    hardRequirementsDesc: 'Voraussetzung für Projektstart',
    softRequirements: 'Soft Requirements',
    softRequirementsDesc: 'Beeinflusst Umsetzungsgeschwindigkeit',
    noHardRequirements: 'Keine Hard Requirements vorhanden',
    noSoftRequirements: 'Keine Soft Requirements vorhanden',
    addHardRequirement: 'Hard Requirement hinzufügen',
    addSoftRequirement: 'Soft Requirement hinzufügen',
    requirementModal: {
      editTitle: 'Requirement bearbeiten',
      addTitle: 'Neues Global Requirement',
      namePlaceholder: 'z.B. Zusätzlicher Entwickler',
      descriptionPlaceholder: 'Warum wird dieses Requirement benötigt?',
    },
    byDate: 'bis {{kw}} ({{date}})',
    hardLabel: 'Hard:',
    softLabel: 'Soft:',
    calendarWeek: 'KW {{week}}',
    taskCount: '{{count}} Tasks',
  },
  doubleBooking: {
    title: 'Doppelbelegungen',
    weekOverlap_one: '{{count}} Woche Überlappung',
    weekOverlap_other: '{{count}} Wochen Überlappung',
    assignedTo: 'Gleichzeitig zugewiesen zu:',
  },
  importModal: {
    title: 'Ansicht importieren',
    placeholder: 'JSON hier einfügen...',
    invalidVersion: 'Ungültige Version',
    invalidFormat: 'Ungültiges Format: tasks oder allTasks fehlt',
    invalidJson: 'Ungültiges JSON',
    importButton: 'Importieren',
    escHint: 'ESC Abbrechen \u00b7 \u2318+Enter Importieren',
  },
  exportAlert: 'Daten in Zwischenablage kopiert',
  estimates: {
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    optimistic: 'Optimistisch',
    realistic: 'Realistisch',
    pessimistic: 'Pessimistisch',
  },
  addEmployeeModal: {
    title: 'Neuen Mitarbeiter hinzufügen',
    skillsLabel: 'Skills (Emojis)',
    skillsHint: 'Emoji-String für Skills (mehrfache = höheres Level)',
    teamLabel: 'Team',
  },
  addTeamModal: {
    title: 'Neues Team hinzufügen',
  },
  canvas: {
    contentError: 'Inhalt fehlerhaft',
    clearContent: 'Inhalt leeren',
    renderError: 'Darstellungsfehler',
  },
  board: {
    saveButton: 'Speichern',
    shiftSelected: 'Ausgewählte',
    shiftTasks: 'Tasks verschieben',
    shiftPresets: 'Voreinstellungen',
    shiftLeft: 'Tage nach links',
    shiftRight: 'Tage nach rechts',
    customDays: 'Benutzerdefiniert (Tage)',
    setStartDate: 'Startdatum setzen',
    moveButton: 'Verschieben',
    moveHint: 'Frühester Task → Datum, Rest behält Abstand',
    daysPlaceholder: 'Tage',
    moveToDateTitle: '{{target}} Tasks auf Datum verschieben (frühester Task -> Datum, Rest relativ)',
  },
  presets: {
    addFromPreset: 'Aus Preset hinzufügen',
    selectFromGroups: 'Skills aus vordefinierten Gruppen auswählen',
    available: '{{count}} verfügbar',
    alreadyExists: 'bereits vorhanden',
    selectedCount: '{{count}} Skill(s) ausgewählt',
    noneSelected: 'Keine Skills ausgewählt',
    addSelected: 'Ausgewählte hinzufügen',
  },
  language: {
    de: 'Deutsch',
    en: 'English',
  },
  boardv3: {
    contextMenu: {
      assign: 'Zuweisen',
      duplicate: 'Duplizieren',
      splitAt: 'Splitten am {{date}}',
      removeFromBoard: 'Vom Board entfernen',
      delete: 'Löschen',
      detailLevel: 'Detailstufe',
      addNewTask: 'Neuen Task hinzufügen',
      selectAll: 'Alle Tasks markieren',
      openTaskPool: 'Task-Pool öffnen',
      editColumn: 'Column bearbeiten',
      deleteColumn: 'Column löschen',
    },
    detailLevels: {
      auto: 'Automatisch',
      minimal: 'Minimal',
      kompakt: 'Kompakt',
      normal: 'Normal',
      detailliert: 'Detailliert',
    },
    headerMenu: {
      auto: 'Automatisch',
      showYears: 'Jahre anzeigen',
      showMonths: 'Monate anzeigen',
      showDays: 'Tage anzeigen',
    },
    toolbar: {
      moveToolbar: 'Toolbar verschieben (Doppelklick = zurücksetzen)',
      openToolbar: 'Toolbar öffnen',
      shiftTasks: 'Tasks verschieben',
      undo: 'Rückgängig',
      view: 'Ansicht',
      addNewTask: 'Neuen Task hinzufügen',
      openTaskPool: 'Task-Pool öffnen',
      removeSelectedFromBoard: 'Ausgewählte Tasks vom Board entfernen',
      deleteSelected: 'Ausgewählte Tasks löschen',
    },
    assigneePicker: {
      searchPlaceholder: 'Suche nach Name, Team, Skills...',
      all: 'Alle',
      assigned: 'Zugewiesen ({{count}})',
      available: 'Verfügbar ({{count}})',
      noEstimate: 'Kein Estimate ({{count}})',
      noEmployeesFound: 'Keine Mitarbeiter gefunden',
    },
    selection: {
      tasksSelected: '{{count}} Tasks ausgewählt',
      removeFromSelection: 'Aus Auswahl entfernen',
      addToSelection: 'Zur Auswahl hinzufügen',
      searchTask: 'Task suchen...',
      noResults: 'Keine Treffer',
    },
    viewSettings: {
      navigation: 'Navigation',
      header: 'Header',
      sidebar: 'Sidebar',
      tasks: 'Tasks',
      toolbar: 'Toolbar',
      cwAlwaysVisible: 'KW immer sichtbar',
      show: 'einblenden',
      hide: 'ausblenden',
      on: 'Ein',
      off: 'Aus',
    },
    taskPool: {
      all: 'Alle',
      searchTask: 'Task suchen...',
      noTasksFound: 'Keine Tasks gefunden für "{{query}}"',
      resetSearch: 'Suche zurücksetzen',
      allTasksOnBoard: 'Alle Tasks sind bereits auf diesem Board',
      noMatchingTasks: 'Keine passenden Tasks für die aktiven Filter',
      addToBoard: 'Zum Board hinzufügen',
      add: 'Hinzufügen',
    },
    sidebar: {
      expand: 'Sidebar aufklappen',
    },
    columnHeader: {
      clickForOptions: '{{column}} – Klicken für Optionen',
    },
  },
  canvasMenu: {
    deselect: 'Markierung aufheben',
    select: 'Markieren',
    copy: 'Kopieren',
    cut: 'Ausschneiden',
    duplicate: 'Duplizieren',
    copyAsImage: 'Als Bild kopieren',
    background: 'Hintergrund',
    add: 'Hinzufügen',
    paste: 'Einfügen',
    group: 'Gruppieren',
    selectAllNodes: 'Alle Nodes markieren',
    spriteClickThroughOff: 'Sprite Click-Through aus',
    spriteClickThroughOn: 'Sprite Click-Through ein',
    patternNone: 'Keine',
    patternDots: 'Punkte',
    patternGrid: 'Gitter',
    patternCrossDots: 'Kreuzpunkte',
    patternGraph: 'Karopapier',
    deleteConnection: 'Verbindung löschen',
    deleteConnections: '{{count}} Verbindungen löschen',
    split: 'Aufteilen',
    palette: 'Palette...',
    noBorder: 'Kein Rahmen',
    removeFromAllGroups: 'Aus allen Gruppen entfernen',
    assignGroup: 'Gruppe zuordnen...',
    groupLabel: 'Gruppe',
    removeCount: '{{count}} {{label}} entfernen',
    lineColor: 'Linienfarbe',
    lineType: 'Linientyp',
    lineStyle: 'Linienstil',
    lineWidth: 'Linienstärke',
    arrowStart: 'Pfeilstart',
    arrowEnd: 'Pfeilende',
    editLabel: 'Beschriftung bearbeiten',
    labelPrompt: 'Beschriftung:',
    removeLabel: 'Beschriftung entfernen',
    addLabel: 'Beschriftung hinzufügen',
    segmentStraight: 'Gerade',
  },
  canvasToolbar: {
    moveToolbar: 'Toolbar verschieben (Doppelklick = zurücksetzen)',
    openToolbar: 'Toolbar öffnen',
    rotate: 'Drehen',
    undo: 'Rückgängig (Ctrl+Z)',
    redo: 'Wiederholen (Ctrl+Shift+Z)',
    depExplorer: 'Abhängigkeiten erkunden',
    spriteClickThrough: 'Sprite Click-Through',
    addElement: 'Element hinzufügen',
    removeNodes: '{{count}} Node(s) entfernen',
    zoom: 'Zoom',
    fitContent: 'An Inhalt anpassen',
    trees: 'Trees',
    deleteTreeConfirm: 'Tree "{{name}}" löschen?',
    deleteTree: '"{{name}}" löschen',
    newTree: 'Neuer Tree',
    usedColors: 'Verwendet',
    mixed: 'gemischt',
    on: 'ein',
    off: 'aus',
  },
  canvasPicker: {
    assignGroup: 'Gruppe zuordnen',
    searchGroup: 'Gruppe suchen...',
    noGroupsFound: 'Keine Gruppen gefunden',
    noGroups: 'Keine Gruppen vorhanden',
    member: 'Mitglied',
    addTask: 'Task hinzufügen',
    searchTask: 'Task suchen...',
    noTasksFound: 'Keine Tasks gefunden',
    allTasksInTree: 'Alle Tasks bereits im Tree',
  },
  canvasLayer: {
    layers: 'Layers',
    addLayer: 'Layer hinzufügen',
    empty: '(leer)',
    add: 'Hinzufügen',
    hide: 'Ausblenden',
    show: 'Einblenden',
    unlock: 'Entsperren',
    lock: 'Sperren',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    removeLayer: 'Layer entfernen',
    image: 'Bild',
    expandSidebar: 'Sidebar aufklappen',
    hideDeps: 'Abhängigkeiten ausblenden',
    showDeps: 'Abhängigkeiten anzeigen',
  },
  canvasSprite: {
    search: 'Suchen...',
    filterLibrary: 'Bibliothek filtern',
    noResults: 'Keine Ergebnisse',
    loading: 'Lade Sprites...',
    all: 'Alle',
    diagram: 'Diagramm',
  },
  employeeDetail: {
    deleteTitle: 'Löschen',
    closeEsc: 'Schließen (Esc)',
    confirmDelete: 'Mitarbeiter wirklich löschen?',
    willBeDeleted: '"{{name}}" wird dauerhaft gelöscht.',
    yesDelete: 'Ja, löschen',
    color: 'Farbe',
    skillOverview: 'Skill-Übersicht',
    totalPoints: 'Gesamtpunkte',
    expertSkills: 'Experten-Skills',
  },
  boardHeader: {
    exportAlert: 'Ansicht in Zwischenablage kopiert!',
    compactTitle: 'Kompakte Ansicht (versteckt auspriorisierte Tasks)',
    compactOn: 'Kompakt \u2713',
    compactOff: 'Kompakt',
    allTasks: 'Alle Tasks:',
    shiftLeft: 'Alle Tasks einen Tag nach links',
    shiftRight: 'Alle Tasks einen Tag nach rechts',
    recalculate: 'Neu berechnen',
    export: 'Exportieren',
    import: 'Importieren',
    zoom: 'Zoom:',
    zoomOut: 'Herauszoomen (Strg+-)',
    zoomIn: 'Hineinzoomen (Strg++)',
    zoomReset: 'Zoom zurücksetzen',
  },
  categorySelect: {
    removeCategory: '{{name}} entfernen',
    categories: 'Kategorien',
    noMore: 'Keine weiteren Kategorien',
    createNew: 'Neue Kategorie erstellen',
    noneAssigned: 'Keine Kategorien zugewiesen',
  },
  emojiPicker: {
    chooseEmoji: 'Emoji wählen',
    searchEmoji: 'Emoji suchen...',
  },
  skillRequirements: {
    label: 'Benötigte Skills',
    levelHint: 'Skill-Level (0 = nicht benötigt, 3 = Experte)',
  },
  estimatesEditor: {
    copyFromLast: 'Vom letzten Task übernehmen',
  },
  canvasEntity: {
    // Shared color names
    colorGray: 'Grau',
    colorDark: 'Dunkel',
    colorBlue: 'Blau',
    colorGreen: 'Gruen',
    colorRed: 'Rot',
    colorOrange: 'Orange',
    colorPurple: 'Lila',
    colorLight: 'Hell',
    colorWhite: 'Weiss',
    colorYellow: 'Gelb',
    colorLightBlue: 'Hellblau',
    // Stroke styles
    strokeSolid: 'Durchgezogen',
    strokeLongDash: 'Lange Striche',
    strokeDashed: 'Gestrichelt',
    strokeShortDash: 'Kurze Striche',
    strokeDotted: 'Gepunktet',
    strokeDashDot: 'Strich-Punkt',
    strokeDashDotDot: 'Strich-Punkt-Punkt',
    // Arrow types
    arrowNone: 'Keiner',
    arrowArrow: 'Pfeil',
    arrowOpen: 'Offener Pfeil',
    arrowTriangle: 'Dreieck',
    arrowDiamond: 'Diamant',
    arrowCircle: 'Kreis',
    arrowBar: 'Balken',
    arrowSquare: 'Quadrat',
    // Border
    borderNone: 'Keine',
    noBorder: 'Kein Rahmen',
    // Toolbar labels
    background: 'Hintergrund',
    backgroundColor: 'Hintergrundfarbe',
    textColor: 'Textfarbe',
    borderColor: 'Rahmenfarbe',
    borderWidth: 'Rahmenstärke',
    strokeWidth: 'Linienstärke',
    cornerRadius: 'Eckenradius',
    connectors: 'Connectors',
    shape: 'Form',
    mode: 'Modus',
    fontSize: 'Schriftgröße',
    fontWeight: 'Schriftstil',
    color: 'Farbe',
    size: 'Größe',
    fixedStroke: 'Fixe Linienstärke',
    opacity: 'Opazitaet',
    collapse: 'Einklappen',
    connectorType: 'Verbindungstyp',
    lineColor: 'Linienfarbe',
    lineStyle: 'Linienstil',
    arrowStart: 'Pfeilstart',
    arrowEnd: 'Pfeilende',
    clickThrough: 'Click-Through',
    // Context menu
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    editText: 'Text bearbeiten',
    editGroupLabel: 'Label bearbeiten',
    editDescription: 'Beschreibung bearbeiten',
    connectorsOff: 'Connectors aus',
    connectorsOn: 'Connectors ein',
    deleteConnector: 'Verbindung löschen',
    deleteWaypoint: 'Connector löschen',
    removeFromTree: 'Aus Tree entfernen',
    showDependencies: 'Abhaengigkeiten anzeigen',
    dissolveGroup: 'Gruppierung aufloesen',
    expand: 'Ausklappen',
    invisibleMode: 'Unsichtbar-Modus',
    containerMode: 'Container-Modus',
    strokeScaling: 'Linienstärke skalierend',
    strokeFixed: 'Linienstärke fixieren',
    customValue: 'Eigener Wert',
    // Multi-delete labels
    connections: 'Verbindungen',
    elements: 'Elemente',
    nodes: 'Nodes',
    // Picker labels
    image: 'Bild',
    group: 'Gruppe',
    // Prompt texts
    groupLabelPrompt: 'Gruppen-Label:',
    descriptionPrompt: 'Beschreibung:',
    // Sprite stroke widths
    strokeThin: 'Duenn (1)',
    strokeLight: 'Leicht (1.5)',
    strokeNormal: 'Normal (2)',
    strokeMedium: 'Mittel (3)',
    strokeThick: 'Dick (4)',
    // Click-through
    ctAlways: 'Immer',
    ctNever: 'Nie',
    // Font weight
    fontNormal: 'Normal',
    fontBold: 'Fett',
    // Corner radius
    round: 'Rund',
    // Image border radius
    brNone: 'Keine (0)',
    brSmall: 'Klein (4)',
    brMedium: 'Mittel (8)',
    brLarge: 'Gross (16)',
    // Shape types
    shapeRect: 'Rechteck',
    shapeEllipse: 'Ellipse',
    shapeDiamond: 'Raute',
    shapeTriangle: 'Dreieck',
    // Display modes
    modeContainer: 'Container',
    modeInvisible: 'Unsichtbar',
    // Segment types
    segmentBezier: 'Bezier',
    segmentStraight: 'Gerade',
    segmentL: 'L',
    segment45: '45°',
    segment90: '90°',
  },
  adr: {
    title: 'ADR',
    newAdr: 'Neues ADR',
    editAdr: 'ADR bearbeiten',
    context: 'Kontext',
    decision: 'Entscheidung',
    consequences: 'Konsequenzen',
    contextPlaceholder: 'Welches Problem wird adressiert?',
    decisionPlaceholder: 'Was wurde entschieden?',
    consequencesPlaceholder: 'Welche Konsequenzen ergeben sich?',
    scope: 'Scope',
    scopeGlobal: 'Global',
    scopeBoard: 'Board',
    scopeCanvas: 'Canvas',
    status: {
      label: 'Status',
      draft: 'Entwurf',
      proposed: 'Vorgeschlagen',
      accepted: 'Akzeptiert',
      deprecated: 'Veraltet',
      superseded: 'Ersetzt',
    },
    implStatus: {
      label: 'Implementierung',
      pending: 'Ausstehend',
      in_progress: 'In Bearbeitung',
      done: 'Erledigt',
      abandoned: 'Aufgegeben',
    },
    relation: {
      label: 'Beziehungen',
      supersedes: 'Ersetzt',
      superseded_by: 'Ersetzt durch',
      amends: 'Ergänzt',
      amended_by: 'Ergänzt durch',
      relates_to: 'Bezieht sich auf',
      add: 'Beziehung hinzufügen',
      searchAdr: 'ADR suchen...',
      noResults: 'Keine ADRs gefunden',
    },
    person: {
      label: 'Personen',
      author: 'Autor',
      responsible: 'Verantwortlich',
      reviewer: 'Reviewer',
      add: 'Person hinzufügen',
      searchEmployee: 'Mitarbeiter suchen...',
    },
    comment: {
      label: 'Kommentare',
      reply: 'Antworten',
      resolve: 'Geklärt',
      unresolve: 'Wieder öffnen',
      addComment: 'Kommentar hinzufügen',
      placeholder: 'Kommentar schreiben...',
      resolved: 'Geklärt',
    },
    sidebar: {
      title: 'ADRs',
      search: 'ADR suchen...',
      newAdr: 'Neues ADR',
      noResults: 'Keine ADRs gefunden',
      global: 'Global',
      board: 'Board',
      canvas: 'Canvas',
    },
    detailSidebar: {
      title: 'ADR Detail',
      expandSidebar: 'ADR-Detail aufklappen',
    },
    trigger: {
      label: 'ADR Trigger',
      openAdr: 'ADR öffnen',
      showAdrs: 'ADRs anzeigen',
      addAdr: 'ADR hinzufügen',
      removeAdr: 'ADR entfernen',
      deleteTrigger: 'Trigger löschen',
      color: 'Farbe',
    },
    overview: {
      subtitle: '{{count}} ADRs',
      subtitleFiltered: '{{count}} ADRs ({{filtered}} angezeigt)',
      searchPlaceholder: 'ADR suchen...',
      noAdrs: 'Keine ADRs',
      noAdrsDesc: 'Erstelle ein ADR, um Architekturentscheidungen zu dokumentieren.',
      noResults: 'Keine ADRs für die aktiven Filter gefunden.',
      addButton: 'Neues ADR',
      updated: 'Aktualisiert',
      scope: 'Scope',
    },
    deleteConfirm: 'ADR wirklich löschen?',
    tabs: {
      general: 'Allgemein',
      content: 'Inhalt',
      people: 'Personen',
      relations: 'Beziehungen',
      comments: 'Kommentare',
    },
  },
  resource: {
    title: 'Resource',
    newResource: 'Neue Resource',
    editResource: 'Resource bearbeiten',
    name: 'Name',
    category: 'Kategorie',
    scope: 'Scope',
    scopeGlobal: 'Global',
    scopeBoard: 'Board',
    scopeCanvas: 'Canvas',
    field: {
      label: 'Felder',
      addField: 'Feld hinzufügen',
      removeField: 'Feld entfernen',
      fieldName: 'Feldname',
      fieldType: 'Typ',
      fieldUnit: 'Einheit',
      fieldValue: 'Wert',
      primary: 'Primär',
      showOnBadge: 'Auf Badge anzeigen',
      aggregation: 'Aggregation',
      interval: 'Intervall',
      types: { text: 'Text', number: 'Zahl', currency: 'Währung', percentage: 'Prozent', duration: 'Dauer' },
      aggregations: { sum: 'Summe', avg: 'Durchschnitt', min: 'Minimum', max: 'Maximum', none: 'Keine' },
      intervals: { monthly: 'Monatlich', yearly: 'Jährlich', hourly: 'Stündlich' },
    },
    catalog: { search: 'Resource suchen...', newBlank: 'Neue leere Resource', noResults: 'Keine Treffer' },
    sidebar: { search: 'Resource suchen...', newResource: 'Neue Resource', noResults: 'Keine Resources gefunden', global: 'Global', board: 'Board', canvas: 'Canvas' },
    detailSidebar: {
      title: 'Resource Detail',
      expandSidebar: 'Resource-Detail aufklappen',
      openOverview: 'Canvas-Übersicht öffnen',
      boardStats: 'Board-Nutzung',
      usedOnCanvases: 'Verwendet auf {{count}} Canvas',
      usedOnCanvas: 'Verwendet auf 1 Canvas',
      totalAttachments: '{{count}} Zuordnungen gesamt',
      canvasLabel: 'Canvas',
      attachments: 'Zuordnungen',
      notUsed: 'Noch nicht verwendet',
      notUsedHint: 'Ziehe diese Resource auf Entities im Canvas.',
      aggregatedValues: 'Aggregierte Werte',
    },
    badge: { deleteBadge: 'Badge löschen' },
    overview: {
      subtitle: '{{count}} Resources',
      subtitleFiltered: '{{count}} Resources ({{filtered}} angezeigt)',
      searchPlaceholder: 'Resource suchen...',
      noResources: 'Keine Resources',
      noResourcesDesc: 'Erstelle eine Resource um wiederverwendbare Infrastruktur-Komponenten zu definieren.',
      noResults: 'Keine Resources für aktive Filter gefunden.',
      addButton: 'Neue Resource',
    },
    canvasOverview: {
      title: 'Canvas Resource-Übersicht',
      totalCost: 'Gesamtkosten',
      totalResources: 'Resources',
      totalEntities: 'Entities',
      perMonth: '/Monat',
      perYear: '/Jahr',
      name: 'Name',
      category: 'Kategorie',
      entities: 'Entities',
      total: 'Gesamt',
      noResources: 'Keine Resources auf diesem Canvas. Ziehe Resources aus der Sidebar auf Entities.',
      noResults: 'Keine Resources für aktive Filter gefunden.',
      allCategories: 'Alle Kategorien',
      allTypes: 'Alle Typen',
      search: 'Resource suchen...',
    },
    deleteConfirm: 'Resource wirklich löschen?',
  },
} as const satisfies Record<string, unknown>;

export type TranslationSchema = { [K in keyof typeof de]: typeof de[K] extends Record<string, unknown> ? { [K2 in keyof typeof de[K]]: typeof de[K][K2] extends Record<string, unknown> ? { [K3 in keyof typeof de[K][K2]]: string } : string } : string };

export default de;
